import api from '../axiosConfig';

const API_URL = '/api/raw-stock-codes';

export const fetchRawStockCodes = () => api.get(API_URL);
export const getRawStockCodeById = (id) => api.get(`${API_URL}/${id}`);
export const createRawStockCode = (data) => api.post(API_URL, data);
export const updateRawStockCode = (id, data) => api.put(`${API_URL}/${id}`, data);
export const deleteRawStockCode = (id) => api.delete(`${API_URL}/${id}`); 